import { filterMonthKeysByDateRange } from '../../utils/chart-movements/month-key-utils';

export function filterMonthColumns(
  allMonthKeys: string[],
  fromDate?: Date | null,
  toDate?: Date | null,
): string[] {
  return filterMonthKeysByDateRange(allMonthKeys, fromDate ?? null, toDate ?? null);
}
